import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/verify")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_private/verifi"!</div>;
}
